import React from "react";
import PageHeader from "./global-components/page-header";
import Intro from "./section-components/intro-v3";
import About from "./section-components/about";
import Team from "./section-components/team";
import Footer from "./global-components/footer";
import usePageMeta from "./global-components/use-page-meta";

const AboutPage = () => {
  usePageMeta(
    "O nama | Prokurator d.o.o. Split — vanjsko oglašavanje i digitalni marketing",
    "Prokurator d.o.o. iz Splita, osnovan 2012.: mreža od 500+ oglasnih površina diljem Hrvatske, dizajn, print i montaža te digitalni marketing."
  );

  return (
    <div>
      <PageHeader headertitle="About Us" />
      <Intro />
      <About />
      <Team />
      <Footer />
    </div>
  );
};

export default AboutPage;
